import ContractIcon from './ContractIcon'

export default ContractIcon
